import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-modal-detalhes-rol-responsaveis',
  templateUrl: 'modal-detalhes-rol-responsaveis.html'
})
export class ModalDetalhesRolResponsaveisPage {
  titulo: string;
  objeto: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalDetalhesRolResponsaveisPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-detalhes-rol-responsaveis/modal-detalhes-rol-responsaveis.ts